import React, { useEffect, useState } from "react";
import { getClasses } from "../../../../services/trialClassService";
import { Button, Form } from "antd";
import { getParams } from "../../../../utilities/filterConstructor";
import ClassTable from "./ClassTable";
import ClassAdd from "./ClassAdd";

const Classes = () => {
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [offset, setOffset] = useState((current - 1) * pageSize);

  const [classes, setClasses] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [error, setError] = useState(false);
  const [currentParams, setCurrentParams] = useState({});

  const [visibleAddModal, setVisibleAddModel] = useState(false);
  const onClickModal = () => {
    setVisibleAddModel(true);
  };

  const getData = (newParams, limit = pageSize, currentPage = current) => {
    const params = newParams ? newParams : currentParams;
    getClasses(currentPage, limit, params)
      .then((res) => {
        if (!res.error) {
          setClasses(res.data.data.paginatedList);
          setTotalCount(res.data.data.totalCount);
        } else {
          console.log(res.error);
          setError(error);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const onPaginationChange = (data) => {
    getData(currentParams, data.pageSize, data.current);
    setCurrent(data.current);
    setPageSize(data.pageSize);
    setOffset((data.current - 1) * data.pageSize);
  };

  useEffect(() => {
    getData();
  }, [current, currentParams]);

  const [form] = Form.useForm();

  const onSearch = (data) => {
    const params = getParams(data);
    setCurrentParams(params);
    setCurrent(1);
  };

  const onReset = () => {
    form.resetFields();
    getData({}, 1);
  };

  return (
    <div>
      <div
        style={{
          float: "right",
        }}
      >
        <Button type="ghost" onClick={onClickModal}>
          Add
        </Button>
      </div>

      <ClassAdd
        isOpen={visibleAddModal}
        toggle={() => setVisibleAddModel(false)}
      />

      <ClassTable
        data={classes}
        onPaginationChange={onPaginationChange}
        totalCount={totalCount}
        offset={offset}
        pageSize={pageSize}
      />
    </div>
  );
};

export default Classes;
